import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { primitive } from 'styles/constants/primitives';

export const PriceAndCaloriesText = styled.h2`
  font: ${brandFont.headerThree};
  color: ${({ theme }) => theme.token('text-default')};
  width: 100%;
  text-align: center;
  text-transform: capitalize;
  margin-top: 0;
  margin-bottom: ${primitive.$spacing3};
`;
